 /*jshint esversion: 6 */

 import Vue from 'vue'
 import Router from 'vue-router'
 import Reader from '@/components/Reader'
 import Home from '@/components/home'
 import COVER from '@/components/cover'
 import EBB from '@/components/EBB'
 import TLU from '@/components/TLU'
 import MM from '@/components/MM'
 import LOVE1 from '@/components/love1'
 import TITLEPAGE from '@/components/Titlepage'
 import A7815040781082 from '@/components/9781504078108-2'
 import A7815040781083 from '@/components/9781504078108-3'
 import A7815040781084 from '@/components/9781504078108-4'
 import A7815040781085 from '@/components/9781504078108-5'
 import A7815040781086 from '@/components/9781504078108-6'
 import A7815040781087 from '@/components/9781504078108-7'
 import LOVE2 from '@/components/love2'
 import A7815040781088 from '@/components/9781504078108-8'
 import PREVIEWPREVIEW from '@/components/Preview/preview'
 import PREVIEWCOVER from '@/components/Preview/cover'
 import PREVIEW03_PROLOGUE from '@/components/Preview/03_Prologue'
 import PREVIEW05_PT1_CHAPTER01 from '@/components/Preview/05_Pt1_chapter01'
 import PREVIEW06_PT1_CHAPTER02 from '@/components/Preview/06_Pt1_chapter02'
 import A7815040781089 from '@/components/9781504078108-9'
 import COPYRIGHT from '@/components/copyright'
 import SERIESBACKAD from '@/components/seriesbackad'
 import ORIMAD from '@/components/ORIM-ad'
import Last from '@/components/last'

Vue.use(Router)

export default new Router({
	routes: [
	{
 			"path" : "/",
 			"name" : "home",
 			"component" : Home
 		},
 		{
 			"path" : "/cover",
 			"name" : "cover",
 			"component" : COVER
 		},
 		{
 			"path" : "/EBB",
 			"name" : "EBB",
 			"component" : EBB
 		},
 		{
 			"path" : "/TLU",
 			"name" : "TLU",
 			"component" : TLU
 		},
 		{
 			"path" : "/MM",
 			"name" : "MM",
 			"component" : MM
 		},
 		{
 			"path" : "/love1",
 			"name" : "love1",
 			"component" : LOVE1
 		},
 		{
 			"path" : "/Titlepage",
 			"name" : "Titlepage",
 			"component" : TITLEPAGE
 		},
 		{
 			"path" : "/9781504078108-2",
 			"name" : "9781504078108-2",
 			"component" : A7815040781082
 		},
 		{
 			"path" : "/9781504078108-3",
 			"name" : "9781504078108-3",
 			"component" : A7815040781083
 		},
		{
 			"path" : "/last",
 			"name" : "last",
 			"component" : Last
 		},
	]
})


// WEBPACK FOOTER //
// ./src/router/index.js